import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Components from 'components';
import Plugins from 'plugins';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.start();

// Replace 'no-js' class with 'js' on the HTML element
document.documentElement.classList.replace('no-js', 'js');

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function($) {
    Components.init();
    Plugins.init();

    document.querySelectorAll('.layotabs').forEach(function(block) {
        let tabs = block.querySelector('.block-tabs');

        block.querySelectorAll('.layogroup').forEach(function(tab) {
            let title = tab.getAttribute('data-title');
            let id = tab.getAttribute('data-id');

            tab.classList.add('data-[active]:block');
            tab.classList.add('hidden');

            let li = document.createElement('li');
            li.className = 'block-tab py-2 px-6 rounded-full cursor-pointer transition-colors hover:bg-inverse/20 data-[active]:bg-inverse data-[active]:text-current-bg';
            li.setAttribute('data-id', id);
            li.textContent = title;
            tabs.appendChild(li);
        });

        tabs.querySelector('.block-tab').setAttribute('data-active', true);
        block.querySelector('.layogroup').setAttribute('data-active', true);
    });

    document.addEventListener('click', function(event) {
        if (event.target.matches('.layotabs.active .block-tab')) {
            let id = event.target.getAttribute('data-id');
            let block = event.target.closest('.layotabs');
            let tabs = block.querySelector('.block-tabs');

            tabs.querySelectorAll('.block-tab').forEach(function(tab) {
                tab.removeAttribute('data-active');
            });
            event.target.setAttribute('data-active', true);

            block.querySelectorAll('.layogroup').forEach(function(othetab) {
                othetab.removeAttribute('data-active');
            });
            block.querySelector(`.layogroup[data-id="${id}"]`).setAttribute('data-active', true);
        }
    });

    if (document.body.classList.contains('single-post') || document.body.classList.contains('single-client')) {
        let contents = document.getElementById('contents');

        if(contents !== undefined) {
            document.querySelectorAll('.wp-block-heading').forEach(function(heading, index) {
                if (['H1', 'H2', 'H3', 'H4'].includes(heading.tagName)) {
                    let id = heading.getAttribute('id') || 'heading-' + index;
                    heading.setAttribute('id', id);

                    let content = heading.innerText;

                    let a = document.createElement('a');
                    a.className = 'btn clear light';
                    a.setAttribute('href', '#' + id);
                    a.textContent = content;

                    contents.appendChild(a);
                }
            });
        }
    }

    document.addEventListener('click', function(event) {
        if (event.target.tagName === 'A' && event.target.getAttribute('href').startsWith('#')) {
            let targetId = event.target.getAttribute('href').substring(1);
            let targetElement = document.getElementById(targetId);

            if (targetElement) {
                let formBorderElement = targetElement.querySelector('.form-border');
                if (formBorderElement) {
                    formBorderElement.classList.add('border-primary');

                    let textInput = formBorderElement.querySelector('input[type="text"]');
                    if (textInput) {
                        textInput.focus();
                    }
                }
            }
        }
    });
});
